import * as Yup from "yup";

const MIN_TITLE_LENGTH: number = 3;
const MAX_TITLE_LENGTH: number = 50;


const AddCategoryValidator = Yup.object({
    description : Yup.string()
        .required("Name is Required")
        .min(
            MIN_TITLE_LENGTH,
            `Name must be at least ${MIN_TITLE_LENGTH} characters long`
        )
        .max(
            MAX_TITLE_LENGTH,
            `Name must be less than ${MAX_TITLE_LENGTH} characters long`
        ),
    image_name : Yup.string()
        .test(
            "is-jpg",
            "Image must be a valid jpg/jpeg,png,webp and svg image file",
            function (value) {
                if (!value) return true; // Skip validation if the field is empty
                value = value.toLowerCase();

                const validExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".svg"];
                // Check if the file has a valid extension
                const isValid = validExtensions.some(extension => value.endsWith(extension));
                return isValid;
            }
        )
        .test(
            "is-required",
            "Image is Required",
            function (value) {
                const { level } = this.parent;
                if(level === 2 && !value) return false;
                return true;
            }
        )
});

export default AddCategoryValidator;